import React from 'react';
import PropTypes from 'prop-types';

const Actor = ({
  name,
}) => (
  <span>
    {name}
  </span>
);
Actor.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Actor;
